import { useEffect, useState } from 'react';
import { Dropdown, DropdownChangeEvent } from '../../Common/Imports';
import { DDModel } from '../../Models/Classes';
import { ContactType } from '../../Models/Enums';
import { useTranslation } from 'react-i18next';


interface DDDaysOfWeekProps {
    value?: number | undefined,
    onSelect?: (type: number) => void;
}


export const DDDaysOfWeek: React.FC<DDDaysOfWeekProps> = ({ onSelect, value }) => {
    const { t } = useTranslation();
    const [data] = useState<DDModel<number>[]>([
        {
            label: t("Common.DaysOfWeek.Monday"),
            id: 1,
            data: 1
        },
        {
            label: t("Common.DaysOfWeek.Tuesday"),
            id: 2,
            data: 2
        },
        {
            label: t("Common.DaysOfWeek.Wednesday"),
            id: 3,
            data: 3
        },
        {
            label: t("Common.DaysOfWeek.Thursday"),
            id: 4,
            data: 4
        },
        {
            label: t("Common.DaysOfWeek.Friday"),
            id: 5,
            data: 5
        },
        {
            label: t("Common.DaysOfWeek.Saturday"),
            id: 6,
            data: 6
        },
        {
            label: t("Common.DaysOfWeek.Sunday"),
            id: 0,
            data: 0
        },
    ]);
    const [selectedElem, setSelectedElem] = useState<DDModel<ContactType> | undefined>();

    useEffect(() => {
        if (value || value === 0) {
            setSelectedElem(data.filter((m: DDModel<number>) => m.data == value)[0])
        }
    }, [data, selectedElem, value]);

    const handleChange = (e: DropdownChangeEvent) => {
        const _val = e.value as DDModel<ContactType> | undefined;
        setSelectedElem(_val);
        if (onSelect && e) {
            onSelect(e.value.data);
        }
    };
    return (
        <Dropdown
            value={selectedElem}
            onChange={handleChange}
            options={data}
            optionLabel="label" />
    );
};
